export const JUSBRASIL_NEWS_GA4 = {
  componentClass: 'topbar_user_menu',
  componentName: 'jusbrasil_news_cta',
  selectedOptionClicked: 'jusbrasil_news_clicked',
  selectedOptionFormOpened: 'jusbrasil_news_form_opened',
  selectedOptionUpgradeOpened: 'jusbrasil_news_upgrade_opened',
} as const
